// extracted by extract-css-chunks-webpack-plugin
module.exports = {"list":"list-31ngCYHo","current":"current-2VwtZuaL"};